module.exports = __webpack_public_path__ + "img/bell-horizon.1f4f115d.png";